<template>
  <div>
    <Navbar/>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/4 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-row hidden sm:hidden md:hidden lg:block lg:w-1/4 mx-auto self-center">
                            <!-- <Logo /> -->
                        </div>
                        <div class="vx-row sm:w-full md:w-full lg:w-full mx-auto self-center  d-theme-dark-bg">
                          <div class="px-8 pt-8 organisation-tabs-container">
                            <Subs/>
                          </div>
                        </div>
                    </div>
                 </div>
            </vx-card>
        </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/views/components/quicksend-navbar/Navbar.vue'
import Subs from './SubscriptionComponent'
import router from '@/router';

export default {
  components : {
    Navbar,
    Subs
  },
  data () {
    return {
      loaded: false
    }
  },
  computed: {
  },
  mounted() {
    //this.showRemaining();
  },
  async created() {
    await this.$store.dispatch('subscription/getSubscriptionStatus')
    if(this.$store.state.subscription.status!=="t"){this.$router.push({path: '/dashboard'})}
  },
  methods: {   
  },
}
</script>

<style scoped>
.second {
    max-width: 60px;
}
</style>

